




















































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';

import Card from '@/components/default/Card.vue';
import Popup from '@/components/default/Popup.vue';
import ActionPoint from '../classes/actionPoint';
import CanvasEditor from '@/modules/photoEditor/CanvasEditor.vue';
import ImageUploadPopup from '@/modules/files/components/ImageUploadPopup.vue';
import SaveBar from '@/modules/shared/savebar/SaveBar.vue';

import projectsRepository from '@/services/projectsRepository';

import { DxHtmlEditor } from 'devextreme-vue/html-editor';

import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxItem, DxLabel } from 'devextreme-vue/form';

import { DxNavBar } from 'devextreme-vue';

import DxTextArea from 'devextreme-vue/text-area';

import DxFileUploader from 'devextreme-vue/file-uploader';

import settings from '@/settings.json';

import { ActionPointStatus } from '../enums/actionPointStatus';
import actionPointsRepository from '../repository/actionPointsRepository';

import EventLogsTable from '@/modules/shared/eventlogs/components/EventLogsTable.vue';
import { EventLogsObjectType } from '@/modules/shared/eventlogs/enums';
import subcontractorsRepository from '@/services/subcontractorsRepository';

import { IMailTemplateDto, MailTemplatesClient, MailTemplateType } from '@/data/web-api-client';
import contactsRepository from '@/services/contactsRepository';
import ProjectIsOnHoldPopup from '@/components/projects/ProjectIsOnHoldPopup.vue';

Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {
    Card,
    Popup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxItem,
    DxLabel,
    DxHtmlEditor,
    DxFileUploader,
    CanvasEditor,
    ImageUploadPopup,
    DxTextArea,
    DxNavBar,
    EventLogsTable,
    SaveBar,
    ProjectIsOnHoldPopup,
  },
})
export default class ActionPointDetailPage extends Vue {
  initialised: boolean = false;
  saving: boolean = false;
  actionPoint: ActionPoint = new ActionPoint();
  contacts: IProjectAssignedContactObject[] = [];
  showUploadImagePopup: boolean = false;
  showSendEmailPopup: boolean = false;
  accessToken: string = '';
  savingImage: boolean = false;
  navIndex: number = 0;
  mailDto: IActionPointMailDto = {
    id: '',
    sendToSubcontractor: false,
    sendToExecutor: true,
    sendToReporter: false,
    accompanyingTextSubcontractor: '',
    accompanyingTextReporter: '',
    accompanyingTextExecutor: '',
    mailTemplateSubcontractor: '',
    mailTemplateReporter: '',
    mailTemplateExecutor: '',
  };

  templates: IMailTemplateDto[] = [];

  fieldChanged() {
    this.actionPoint.dirty = true;
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.actionPoint.dirty) {
      if (confirm('Er zijn onopgeslagen wijzigingen. Bent u zeker dat u wenst te veranderen van pagina?')) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }

  mounted() {
    this.loadData();
    this.mailDto.id = this.routeId;
    this.getTemplates();
  }

  async getTemplates() {
    this.templates = await new MailTemplatesClient(undefined, this.$axios).getAll(MailTemplateType.ActionPoint);
  }

  async loadData() {
    await this.actionPoint.init(this.routeId);
    this.accessToken = (await this.$auth.getAccessToken()) as string;
    this.contacts = await projectsRepository.getProjectContacts(this.actionPoint.projectId).then((res) => res.data.map((d) => d.contact));
    setTimeout(() => {
      this.initialised = true;

      if (this.$route.query.checkProjectOnHold === 'true' && this.actionPoint?.projectIsOnHold) {
        this.projectIsOnHoldPopup.show();
      }
    }, 200);
  }

  async showEmailPopup() {
    // Save changes if dirty
    if (this.actionPoint.dirty) {
      await this.actionPoint.saveChanges();
    }

    this.showSendEmailPopup = true;
  }

  async sendMail() {
    try {
      await actionPointsRepository.mail(this.routeId, this.mailDto);

      if (this.actionPoint.status === ActionPointStatus.Open) {
        this.actionPoint.status = ActionPointStatus.Send;
        setTimeout(() => {
          this.actionPoint.dirty = false;
        }, 200);
      }

      this.showSendEmailPopup = false;
      notificationService.showSuccessMessage('Verstuurd!');
    } catch (err) {
      notificationService.showAxiosError(err);
    }
  }

  async setStatus(status: number) {
    try {
      const result = await actionPointsRepository.changeStatus(this.routeId, status);
      this.actionPoint.status = status;
      notificationService.saved();
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  imageUploaded(e: any) {
    const url = `${settings.api}/Api/ActionPoints/${this.routeId}/File?filename=${e.file.name}`;
    this.actionPoint.content += `<img src="${url}" />`;
  }

  async uploadImage(e: any) {
    try {
      this.savingImage = true;
      const result = await actionPointsRepository.uploadFile(this.routeId, e.blob, e.filename);
      const url = `${settings.api}/Api/ActionPoints/${this.routeId}/File?filename=${result.data}`;
      this.actionPoint.content += `<img src="${url}" />`;
      this.showUploadImagePopup = false;
      await this.actionPoint.saveChanges();
      this.savingImage = false;
    } catch (err) {
      notificationService.showErrorMessage('failed to upload image');
    }
  }

  get routeId() {
    return this.$route.params.id;
  }

  get contactsOptions() {
    return {
      dataSource: this.contacts,
      displayExpr: 'displayName',
      valueExpr: 'id',
      searchEnabled: true,
    };
  }

  get subcontractorOptions() {
    return {
      dataSource: this.contacts.filter((o) => o.type === 'Subcontractor'),
      displayExpr: 'displayName',
      valueExpr: 'id',
      searchEnabled: true,
    };
  }

  get categoryOptions() {
    const list = this.$store.getters['catalogs/list']('ActionPointsCategories');

    let items = [];
    if (list) {
      items = list.values;
    }

    return {
      items,
    };
  }

  get statusOptions() {
    const options = [
      { value: ActionPointStatus.Open, text: 'Open' },
      { value: ActionPointStatus.Send, text: 'Verstuurd' },
      { value: ActionPointStatus.Processed, text: 'Uitgevoerd' },
      { value: ActionPointStatus.Ignore, text: 'Negeren' },
      { value: ActionPointStatus.OnHold, text: 'On-hold' },
    ];

    return {
      dataSource: options,
      displayExpr: 'text',
      valueExpr: 'value',
      disabled: true,
    };
  }

  get userOptions() {
    const objects = this.$store.getters['employees/items'];
    return {
      items: objects,
      valueExpr: 'id',
      displayExpr: 'displayName',
      disabled: true,
    };
  }

  get historyConfig(): IEventLogQuery {
    return {
      objectId: this.routeId,
      type: EventLogsObjectType.ActionPoint,
    };
  }

  get fileUploadSettings() {
    return {
      uploadUrl: `${settings.api}/Api/ActionPoints/${this.routeId}/Upload`,
      uploadHeaders: {
        Authorization: `Bearer ${this.accessToken}`,
      },
      uploadMode: 'useButtons',
    };
  }

  get navbarItems() {
    const self = this;
    return [
      { icon: 'fas fa-info-circle', text: 'Info' },
      { icon: 'fas fa-history', text: 'Geschiedenis' },
    ];
  }

  get htmlEditorOptions() {
    const self = this;
    return {
      toolbar: {
        items: [
          'bold',
          'italic',
          'underline',
          'separator',
          'alignLeft',
          'alignCenter',
          'alignRight',
          'alignJustify',
          'separator',
          'orderedList',
          'bulletList',
          'separator',
          'link',
          'image',
          {
            widget: 'dxButton',
            options: {
              icon: 'fas fa-camera',
              onClick: () => {
                self.showUploadImagePopup = true;
              },
            },
          },
          'separator',
          {
            formatName: 'size',
            formatValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
          },
          {
            formatName: 'header',
            formatValues: [false, 1, 2, 3, 4, 5],
          },
        ],
        multiline: false,
      },
      mediaResizing: {
        enabled: true,
      },
    };
  }

  get templateOptionsExecutor() {
    const self = this;
    return {
      dataSource: this.templates,
      valueExpr: 'name',
      displayExpr: 'name',
      visible: self.mailDto.sendToExecutor == true,
      onItemClick: (e: any) => {
        self.mailDto.accompanyingTextExecutor = e.itemData.content;
        self.replaceTags('accompanyingTextExecutor');
      },
    };
  }

  get templateOptionsSubcontractor() {
    const self = this;
    return {
      dataSource: this.templates,
      valueExpr: 'name',
      displayExpr: 'name',
      visible: self.mailDto.sendToSubcontractor == true,
      onItemClick: (e: any) => {
        self.mailDto.accompanyingTextSubcontractor = e.itemData.content;
        self.replaceTags('accompanyingTextSubcontractor');
      },
    };
  }

  get templateOptionsReporter() {
    const self = this;
    return {
      dataSource: this.templates,
      valueExpr: 'name',
      displayExpr: 'name',
      visible: self.mailDto.sendToReporter == true,
      onItemClick: (e: any) => {
        self.mailDto.accompanyingTextReporter = e.itemData.content;
        self.replaceTags('accompanyingTextReporter');
      },
    };
  }

  get title() {
    if (this.actionPoint.projectName && this.actionPoint.projectNumber) {
      return `${this.actionPoint.documentNumber} - ${this.actionPoint.projectName} - ${this.actionPoint.projectNumber}`;
    }

    return this.actionPoint.documentNumber;
  }

  replaceTags(target: string) {
    let mailDto = <any>this.mailDto;
    if (mailDto[target].indexOf('#DocumentNumber') != -1) {
      mailDto[target] = mailDto[target].replace('#DocumentNumber', this.actionPoint ? this.actionPoint.documentNumber : '');
    }
    if (mailDto[target].indexOf('#Titel') != -1) {
      mailDto[target] = mailDto[target].replace('#Titel', this.actionPoint ? this.actionPoint.title : '');
    }
    if (mailDto[target].indexOf('#Priority') != -1) {
      mailDto[target] = mailDto[target].replace('#Priority', this.actionPoint ? this.actionPoint.priority.toString() : '');
    }
    if (mailDto[target].indexOf('#Category') != -1) {
      mailDto[target] = mailDto[target].replace('#Category', this.actionPoint ? this.actionPoint.category : '');
    }
    if (mailDto[target].indexOf('#DeliveryDate') != -1) {
      mailDto[target] = mailDto[target].replace('#DeliveryDate', this.actionPoint ? new Date(this.actionPoint.dueDate).toLocaleDateString() : '');
    }
    if (mailDto[target].indexOf('#ReportedBy') != -1 && this.actionPoint.reportedBy) {
      this.getContact(this.actionPoint.reportedBy).then((result) => {
        mailDto[target] = mailDto[target].replace('#ReportedBy', result ? result.displayName : '');
      });
    }
    if (mailDto[target].indexOf('#CreatedDate') != -1) {
      mailDto[target] = mailDto[target].replace('#CreatedDate', this.actionPoint ? new Date(this.actionPoint.createdOn).toLocaleDateString() : '');
    }
    if (mailDto[target].indexOf('#Subcontractor') != -1 && this.actionPoint.assignedSubcontractorId) {
      this.getSubcontractor(this.actionPoint.assignedSubcontractorId).then((result) => {
        mailDto[target] = mailDto[target].replace('#Subcontractor', result ? result.companyName : '');
      });
    }
    if (mailDto[target].indexOf('#Status') != -1 && this.actionPoint.status != undefined) {
      var t = this.statusOptions.dataSource.find((x) => x.value == this.actionPoint.status)!.text;
      mailDto[target] = mailDto[target].replace('#Status', t);
    }
  }

  public async getSubcontractor(id: string) {
    try {
      const result = await subcontractorsRepository.getSingle(id);
      return result.data;
    } catch {
      notificationService.failedToLoad();
    }
  }

  public async getContact(id: string) {
    try {
      const result = await contactsRepository.getSingle(id);
      return result.data;
    } catch {
      notificationService.failedToLoad();
    }
  }

  get projectIsOnHoldPopup() {
    return this.$refs.projectIsOnHoldPopup as ProjectIsOnHoldPopup;
  }
}
